//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import help from '~/components/vps/help' // 快速帮助
import streamAd from '~/components/vps/streamAd'
import { matomofn } from '~/assets/js/utils.js'
export default {
  components: {
    help,
    streamAd
  },
  async asyncData ({ $api, store, redirect, route }) {
    const {
      locale = 'en',
      cookieVal = '',
      ip = '',
      simpleUser = {},
      countryCode
    } = store.state
    if (cookieVal) {
      // 用户已登录
      const userId = simpleUser?.userId
      const uHost = await $api.burstData
        .newUserHost({ UserId: Number(userId) })
        .catch(() => {})
      if (uHost?.length) return redirect(`/${locale}/jyzh`) // 用户拥有购买的VPS主机，跳转至对应页面
    }
    console.log({ apiCountryCode: countryCode, apiLanguage: locale })
    const res = await Promise.all([
      $api.burstData.newRegionInfoV2Service({ ip }).catch(() => {}),
      $api.home
        .sentimentCurrencyServer(
          { HttpMethod: 'post', Routes: 'fxad$windowv2' },
          { type: 870 }
        )
        .catch(() => {}),
      $api.common
        .v3Server(
          { Routes: 'cloudvpsapi$regioninfov2' },
          { apiCountryCode: countryCode, apiLanguage: locale }
        )
        .catch(() => {}),
      $api.common
        .v3Server(
          {
            Routes: 'fxad$advertisementv2',
            BasicData: store.getters?.getDiffBasic
          },
          { type: 890 }
        )
        .catch(() => {})
    ])
    const { shieldCenterInfo = {} } = res[0]
    const showVPS = shieldCenterInfo.value
    const regionInfo =
      res?.[2]?.cloudvpsapi?.regioninfov2?.data?.typeList || []
    if (store.state.isMobile) regionInfo.splice(3, 0, { Config: 11.5 }) // 手机端特殊处理
    if (route.query?.code) {
      regionInfo?.forEach((item) => {
        if (item.BrokerId == route.query?.code) {
          return redirect(`/${locale}/vpsconfig/${item.Config}.html`)
        }
      })
    }
    const adList = res?.[1]?.fxad?.windowv2?.data || []

    const topAdList = res?.[3]?.fxad?.advertisementv2?.data?.slice(0, 6) || []
    return {
      regionInfo,
      showEA: showVPS == 'true',
      adList,
      shieldCenterInfo,
      topAdList
    }
  },
  data () {
    return {
      position: 0,
      showAdList: [true, true, true, true], // 是否展示对联广告
      pageEnterTime: null, // 页面进入时间
      vsList: [
        {
          bgc: 'linear-gradient(180deg, rgba(112, 182, 238, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)',
          logo: 'https://resources.interface003.com/cloud/img/vps/vps-standard.png',
          name: 'VPS Standard',
          level: '',
          tips: '',
          cpu: '1*CPU',
          cpuTips: '',
          memory: '1G', // 内存
          memoryTips: '',
          hardDisk: '40G',
          hardDiskTips: '',
          bandwidth: '1M',
          bandwidthTips: '',
          flowRate: this.$t('19314'), // 流量
          System: 'Windows 2016',
          lang: '简体中文、繁体中文、English、日本语、ภาษาไทย、Tiếng Việt、اللغة العرب',
          tyd: true,
          djdfg: true,
          EA: true,
          accountLimits: this.$t('19314'),
          Cost: this.$t('CLD_000034')
        },
        {
          bgc: 'linear-gradient(180deg, rgba(242, 192, 109, 0.10) 0%, rgba(255, 255, 255, 0.00) 100%)',
          logo: 'https://resources.interface003.com/cloud/img/vps/vps-ultra.png',
          name: 'VPS Ultra',
          level: '',
          tips: '*' + '  ' + this.$t('TYY_000699'),
          cpu: '2*CPU',
          cpuTips: '100%',
          memory: '2G', // 内存
          memoryTips: '100%',
          hardDisk: '40G',
          hardDiskTips: '',
          bandwidth: '20M',
          bandwidthTips: '2000%',
          flowRate: this.$t('19314'), // 流量
          System: 'Windows 2016',
          lang: '简体中文、繁体中文、English、日本语、ภาษาไทย、Tiếng Việt、اللغة العرب',
          tyd: true,
          djdfg: true,
          EA: true,
          accountLimits: this.$t('19468'),
          Cost: this.$t('CLD_000034')
        },
        {
          bgc: 'linear-gradient(180deg, #E9F0F6 0%, rgba(255, 255, 255, 0.00) 100%)', // 背景色
          logo: 'https://resources.interface003.com/cloud/img/vps/vps-pro.png',
          name: 'VPS Pro',
          level: 'L1',
          tips: '*' + '  ' + this.$t('TYY_000699'),
          cpu: '1*CPU', // 处理器
          cpuTips: '',
          memory: '1G', // 内存
          memoryTips: '',
          hardDisk: '50G', // 硬盘
          hardDiskTips: '25%',
          bandwidth: '2M', // 带宽
          bandwidthTips: '100%',
          flowRate: this.$t('19314'), // 流量
          System: 'Windows 2016',
          lang: '简体中文、繁体中文、English、日本语、ภาษาไทย、Tiếng Việt、اللغة العرب',
          tyd: true,
          djdfg: true,
          EA: true,
          accountLimits: this.$t('19468'),
          Cost: this.$t('CLD_000034')
        },
        {
          bgc: 'linear-gradient(180deg, #E9F0F6 0%, rgba(255, 255, 255, 0.00) 100%)', // 背景色
          logo: 'https://resources.interface003.com/cloud/img/vps/vps-pro.png',
          name: 'VPS Pro',
          level: 'L2',
          tips: '*' + '  ' + this.$t('TYY_000699'),
          cpu: '1*CPU', // 处理器
          cpuTips: '',
          memory: '1G', // 内存
          memoryTips: '',
          hardDisk: '60G', // 硬盘
          hardDiskTips: '50%',
          bandwidth: '2M', // 带宽
          bandwidthTips: '100%',
          flowRate: this.$t('19314'), // 流量
          System: 'Windows 2016',
          lang: '简体中文、繁体中文、English、日本语、ภาษาไทย、Tiếng Việt、اللغة العرب',
          tyd: true,
          djdfg: true,
          EA: true,
          accountLimits: this.$t('19468'),
          Cost: this.$t('CLD_000034')
        },
        {
          bgc: 'linear-gradient(180deg, #E9F0F6 0%, rgba(255, 255, 255, 0.00) 100%)', // 背景色
          logo: 'https://resources.interface003.com/cloud/img/vps/vps-pro.png',
          name: 'VPS Pro',
          level: 'L3',
          tips: '*' + '  ' + this.$t('TYY_000699'),
          cpu: '1*CPU', // 处理器
          cpuTips: '',
          memory: '1G', // 内存
          memoryTips: '',
          hardDisk: '70g', // 硬盘
          hardDiskTips: '75%',
          bandwidth: '2M', // 带宽
          bandwidthTips: '100%',
          flowRate: this.$t('19314'), // 流量
          System: 'Windows 2016',
          lang: '简体中文、繁体中文、English、日本语、ภาษาไทย、Tiếng Việt、اللغة العرب',
          tyd: true,
          djdfg: true,
          EA: true,
          accountLimits: this.$t('19468'),
          Cost: this.$t('CLD_000034')
        },
        {
          bgc: 'linear-gradient(180deg, #E9F0F6 0%, rgba(255, 255, 255, 0.00) 100%)', // 背景色
          logo: 'https://resources.interface003.com/cloud/img/vps/vps-pro.png',
          name: 'VPS Pro',
          level: 'L4',
          tips: '*' + '  ' + this.$t('TYY_000699'),
          cpu: '1*CPU', // 处理器
          cpuTips: '',
          memory: '2G', // 内存
          memoryTips: '100%',
          hardDisk: '70G', // 硬盘
          hardDiskTips: '75%',
          bandwidth: '2M', // 带宽
          bandwidthTips: '100%',
          flowRate: this.$t('19314'), // 流量
          System: 'Windows 2016',
          lang: '简体中文、繁体中文、English、日本语、ภาษาไทย、Tiếng Việt、اللغة العرب',
          tyd: true,
          djdfg: true,
          EA: true,
          accountLimits: this.$t('19468'),
          Cost: this.$t('CLD_000034')
        },
        {
          bgc: 'linear-gradient(180deg, #E9F0F6 0%, rgba(255, 255, 255, 0.00) 100%)', // 背景色
          logo: 'https://resources.interface003.com/cloud/img/vps/vps-pro.png',
          name: 'VPS Pro',
          level: 'L5',
          tips: '*' + '  ' + this.$t('TYY_000699'),
          cpu: '2*CPU', // 处理器
          cpuTips: '100%',
          memory: '2G', // 内存
          memoryTips: '100%',
          hardDisk: '70G', // 硬盘
          hardDiskTips: '75%',
          bandwidth: '2M', // 带宽
          bandwidthTips: '100%',
          flowRate: this.$t('19314'), // 流量
          System: 'Windows 2016',
          lang: '简体中文、繁体中文、English、日本语、ภาษาไทย、Tiếng Việt、اللغة العرب',
          tyd: true,
          djdfg: true,
          EA: true,
          accountLimits: this.$t('19468'),
          Cost: this.$t('CLD_000034')
        }
      ],
      leftNum: 0,
      isControls: false // 是否显示视频控制条
    }
  },
  head () {
    return {
      title: this.$t('19806'),
      meta: [
        { name: 'Keywords', content: this.$t('TYY_000380') },
        { name: 'Description', content: this.$t('19807') }
      ]
    }
  },
  computed: {
    ...mapState(['locale']),
    // 是否为移动端
    isM () {
      return this.$store.state?.isMobile
    },
    isZh () {
      return ['zh', 'zh-cn'].includes(this.locale)
    }
  },
  watch: {
    '$store.state.cookieVal' (val) {
      if (val) window?.location?.reload()
    }
  },
  mounted () {
    // 进入VPS页面，触发统计
    matomofn('VPS_Enter', {}, this.$store.state, this.$cookies)
    // 记录页面进入时间
    this.pageEnterTime = Date.now()
    // 监听页面关闭事件
    window.addEventListener('beforeunload', this.trackPageTime)
    // console.log(this.topAdList, 'topAdList')
    // console.log(this.shieldCenterInfo, 'shieldCenterInfo')
    // console.log(this.regionInfo, 'regionInfo')

    window.addEventListener('resize', () => {
      this.leftNum = 0
      this.position = 0
    })
  },
  beforeDestroy () {
    // 页面销毁前移除事件监听器
    window.removeEventListener('beforeunload', this.trackPageTime)
    // 执行页面时间统计
    this.trackPageTime()
  },
  methods: {
    // 页面时间统计
    trackPageTime () {
      if (this.pageEnterTime) {
        const exitTime = Date.now()
        matomofn('Cloud_VPS_Time', {
          af_Enter: this.pageEnterTime,
          af_Exit: exitTime
        }, this.$store.state, this.$cookies)
      }
    },
    getScreenSize () {
      const width = window.innerWidth
      if (width > 1199) {
        return 'xl'
      } else if (width > 999) {
        return 'lg'
      } else if (width > 799) {
        return 'md'
      } else {
        return 'sm'
      }
    },
    preVs () {
      if (this.leftNum > 0) {
        --this.leftNum
        console.log(this.leftNum, 'leftNum')
        if (this.isRtl()) {
          this.position -= 318 // 向左移动 200px
        } else {
          this.position += 318 // 向左移动 200px
        }
      }
    },
    nextVs () {
      let maxNum = 4
      console.log(this.getScreenSize(), '111')
      if (this.getScreenSize() == 'xl') maxNum = 4
      else if (this.getScreenSize() == 'lg') maxNum = 5
      else if (this.getScreenSize() == 'md') maxNum = 6
      const allow = this.leftNum < maxNum && this.leftNum >= 0
      if (allow) ++this.leftNum
      console.log(this.leftNum)
      if (allow) {
        if (this.isRtl()) {
          this.position += 318 // 向左移动 200px
        } else {
          this.position -= 318 // 向左移动 200px
        }
      }
    },
    // 关闭广告
    closeAdFn (value = 0) {
      this.showAdList?.splice(value, 1, false)
    },
    toBuy (item) {
      console.log(item, 'item')
      matomofn('Cloud_VPS_Click', {
        type: item.title,
        code: '',
        name: ''
      }, this.$store.state, this.$cookies)
      window?.open(
        `/${this.currLangCode()}/vpsconfig/${item.Config}.html?code=${
          item.BrokerId
        }`
      )
    },

    /**
     *
     * @param config 普通1  新专业版4 专属版>=10 专业版2
     */
    getTypeBgColor (config) {
      let type = 'normal-v'
      // let color = 'rgba(92, 138, 229, 0.20)'
      if (config == 1) {
        // color = 'rgba(92, 138, 229, 0.20)'
        type = 'normal-v'
      } else if (config == 4) {
        // color = 'rgba(223, 165, 47, 0.20)'
        type = 'professional-v'
      } else if (config >= 10) {
        // color = 'rgba(230, 97, 18, 0.14)'
        type = 'exclusive-v'
      }
      // console.log(color)
      return type
    },

    playBtn () {
      const myVideo = document.getElementById('myVideo')
      myVideo.play()
      this.isControls = true
    }
  }
}
